@let value = price();

<span>
  $
  @if (value === 0) {
    {{ 'PRICE_ON_REQUEST' | translate }}
  } @else {
    {{ price() | number: '1.0-0' }}
  }
</span>
